/**
 * @generated SignedSource<<fa4564d5b4f77e811804e551188d3b23>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetNoteTextModeAccessoryView_page$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"PageSettingsLeft_page" | "PageSettings_page">;
  readonly " $fragmentType": "WidgetNoteTextModeAccessoryView_page";
};
export type WidgetNoteTextModeAccessoryView_page$key = {
  readonly " $data"?: WidgetNoteTextModeAccessoryView_page$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetNoteTextModeAccessoryView_page">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetNoteTextModeAccessoryView_page",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSettingsLeft_page"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSettings_page"
    }
  ],
  "type": "WidgetNotePage",
  "abstractKey": null
};

(node as any).hash = "6f976c27b4abaacb89a2b13c66315855";

export default node;
